var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.33333V5.16667C2 4.32681 2.36875 3.52136 3.02513 2.9275C3.6815 2.33363 4.57174 2 5.5 2H9M2 21V24.1667C2 25.0065 2.36875 25.812 3.02513 26.4058C3.6815 26.9997 4.57174 27.3333 5.5 27.3333H9M23 2H26.5C27.4283 2 28.3185 2.33363 28.9749 2.9275C29.6313 3.52136 30 4.32681 30 5.16667V8.33333M23 27.3333H26.5C27.4283 27.3333 28.3185 26.9997 28.9749 26.4058C29.6313 25.812 30 25.0065 30 24.1667V21M10.75 14.6667C10.75 15.9264 11.3031 17.1346 12.2877 18.0254C13.2723 18.9162 14.6076 19.4167 16 19.4167C17.3924 19.4167 18.7277 18.9162 19.7123 18.0254C20.6969 17.1346 21.25 15.9264 21.25 14.6667C21.25 13.4069 20.6969 12.1987 19.7123 11.3079C18.7277 10.4171 17.3924 9.91667 16 9.91667C14.6076 9.91667 13.2723 10.4171 12.2877 11.3079C11.3031 12.1987 10.75 13.4069 10.75 14.6667Z",
    stroke: "#bed8d8",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelect);
export default __webpack_public_path__ + "static/media/iconSelect.25fe58fa9e9052128a44ed3f493f010c.svg";
export { ForwardRef as ReactComponent };